import groupBy from "lodash/groupBy";
import { RpSweetAlert } from "@/components/alerts/RpSweetAlert";
import { getFormatDate } from "@/helpers/utils";

type MissedCreativeDetail = {
  location_name?: string;
  creative_name?: string;
};

type MissedDateDetail = {
  location_name?: string;
  subscription_start_date?: unknown;
  subscription_end_date?: unknown;
  start_date?: unknown;
  end_date?: unknown;
};

export const displaySelectLocation = () => {
  RpSweetAlert.fire({
    html: (
      <p className="text-center fw-b text-dark fs-20">
        Hey! It looks like you haven't chosen your locations. Once you do you
        can apply your selections
      </p>
    ),
    confirmButtonText: "OK",
    showCancelButton: false,
    padding: "1rem",
  });
};

export const displayCreativeNotApplied = (
  missedCreativeDetails: MissedCreativeDetail[]
) => {
  const groupByName = groupBy(missedCreativeDetails, "location_name");

  return RpSweetAlert.fire({
    html: (
      <>
        <p className="text-center fw-b text-dark fs-20">
          Hey! Some of the selected creatives not available to some of the
          selected location.
        </p>
        <div
          className="responsive-table w-100"
          style={{ height: 400, overflowY: "auto", overflowX: "hidden" }}
        >
          <table
            className="table table-sm table-bordered table-hover text-left not-available-creative-list"
            style={{ tableLayout: "fixed" }}
          >
            <thead>
              <tr>
                <th>Location</th>
                <th>Not Available Creatives</th>
              </tr>
            </thead>
            <tbody>
              {Object.keys(groupByName)?.map((location_name) => (
                <tr key={location_name}>
                  <td>{location_name}</td>
                  <td>
                    {groupByName[location_name]
                      ?.map((l) => l.creative_name)
                      ?.join(", ")}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </>
    ),
    confirmButtonText: "OK",
    showCancelButton: false,
  });
};

export const displayDateNotInRange = (
  missedDateDetails: MissedDateDetail[]
) => {
  return RpSweetAlert.fire({
    html: (
      <>
        <p className="text-center fw-b text-dark fs-20">
          Hey! Selected dates are not in the subscription range of some of the
          selected locations.
        </p>

        <div
          className="responsive-table w-100"
          style={{ height: 400, overflowY: "auto", overflowX: "hidden" }}
        >
          <table
            className="table table-sm table-bordered table-hover text-left not-available-creative-list"
            style={{ tableLayout: "fixed" }}
          >
            <thead>
              <tr>
                <th>Location</th>
                <th>Subscription Start Date</th>
                <th>Subscription End Date</th>
                <th>Selected Start Date</th>
                <th>Selected End Date</th>
                {/* <th>Min Start Date</th>
                <th>Max Start Date</th>
                <th>Min End Date</th>
                <th>Max End Date</th> */}
              </tr>
            </thead>
            <tbody>
              {missedDateDetails?.map(
                ({
                  location_name,
                  subscription_start_date,
                  subscription_end_date,
                  start_date,
                  end_date,
                  // minStartDate,
                  // maxStartDate,
                  // minEndDate,
                  // maxEndDate,
                }) => (
                  <tr key={location_name}>
                    <td>{location_name}</td>
                    <td>{getFormatDate(subscription_start_date)}</td>
                    <td>{getFormatDate(subscription_end_date)}</td>
                    <td>{getFormatDate(start_date)}</td>
                    <td>{getFormatDate(end_date)}</td>
                    {/* <td>{getFormatDate(minStartDate)}</td>
                    <td>{getFormatDate(maxStartDate)}</td>
                    <td>{getFormatDate(minEndDate)}</td>
                    <td>{getFormatDate(maxEndDate)}</td> */}
                  </tr>
                )
              )}
            </tbody>
          </table>
        </div>
      </>
    ),
    confirmButtonText: "OK",
    showCancelButton: false,
    width: 800,
  });
};
